module.exports = __webpack_public_path__ + "fonts/Roboto-Italic.96da559.woff2";